<template>
  <span>
    <a
      @click.prevent="handleDialog"
      href="#traveler-single-dialog">adicionar novo viajante</a>
    <!-- REGISTER Single Dialog -->
    <single-dialog
      :active="active"
      :large="dialogLarge"
      :id="`traveler-single-dialog`"
      :key="`traveler-single-dialog`"
      @handleDialog="handleDialog"
      class="color-gray-dark">

      <template v-slot:body="{ closeModal, active }">
        <traveler-register
          :formFields="formFields"
          :requiredFields="formFields"
          :key="`traveler-register-${active}`"
          @handleParentAction="closeModal">
          <template v-slot:default="{ handleParentAction }">
            <div class="col-xs-6">
              <button
                @click="handleParentAction"
                type="button"
                class="btn-gray-inverse btn-block btn-extra-large">
                Cancelar
              </button>
            </div>
          </template>
        </traveler-register>
      </template>
    </single-dialog>
    <!-- // Single Dialog -->
  </span>
</template>

<script>
import SingleDialog from '@/components/ui/SingleDialog'
import TravelerRegister from "@/components/forms/TravelerRegister"

export default {
  components: {
    SingleDialog,
    TravelerRegister
  },
  data () {
    return {
      active: false,
      dialogLarge: false,
      formFields: [ 'name', 'birthdate', 'document_number', 'email', 'genero']
    }
  },
  methods: {
    handleDialog () {
      this.active = !this.active;
    }
  }
};
</script>
